export const GET_PRODUCT_FAMILY_NAMES = "GET_PRODUCT_FAMILY_NAMES";
export const GET_EXIST_CHANGE_ORDERS = "GET_EXIST_CHANGE_ORDERS";
export const GET_LAST_UPDATE_DATE = "GET_LAST_UPDATE_DATE";
export const GET_AVAILABLE_HOURS = "GET_AVAILABLE_HOURS";
export const GET_TOTAL_ACTUAL_HOURS = "GET_TOTAL_ACTUAL_HOURS";